import type { ChartOptions, TooltipItem, ScriptableContext } from 'chart.js'

export const chartOptions: ChartOptions<'line'> = {
  ...(isChromatic ? { animation: false } : undefined),
  scales: {
    x: { display: false },
    y: {
      position: 'right',
      grace: '1%',
      ticks: {
        format: { notation: 'standard' },
      },
    },
  },
  hover: { mode: 'nearest', intersect: false },
  backgroundColor: '#50A600', // green-700
  borderColor: '#389200', // green-800
  elements: {
    point: { radius: 1, hoverRadius: 6 },
    line: {
      fill: true,
      tension: 0.4,
      backgroundColor: (context: ScriptableContext<'line'>) => {
        const gradient = context.chart.ctx.createLinearGradient(0, 0, 0, 450)
        gradient.addColorStop(0, 'rgba(174, 210, 52, 0.25)')
        gradient.addColorStop(0.4, 'rgba(174, 210, 52, 0.15)')
        gradient.addColorStop(0.6, 'rgba(174, 210, 52, 0.01)')
        return gradient
      },
    },
  },
  plugins: {
    tooltip: {
      intersect: false,
      backgroundColor: '#fff',
      bodyColor: '#000',
      displayColors: false,
      callbacks: {
        title: () => '',
        label: (tooltipItem: TooltipItem<'line'>) => [tooltipItem.label, tooltipItem.raw as string],
      },
    },
  },
}
